<template>
  <div class="app" @touchmove.prevent>
    <!-- 加载页 -->
    <transition name="fade">
      <loading :progress="loading.progress" v-show="loading.show"></loading>
    </transition>
    <!-- 音乐按钮 -->
    <transition name="fade">
      <div class="app__btns" v-show="scene.show">
        <img src="@/assets/imgs/home/skip.png" @click="skip" class="app__btns__skip">
        <music></music>
      </div>
    </transition>
    <!-- 首页 -->
    <transition name="fade">
      <home v-show="home.show" :showText="home.showText" @toScene="toScene"></home>
    </transition>
    <!-- 场景 -->
    <transition name="fade">
      <scene v-show="scene.show" ref="scene" @action="action" @skip="skip"></scene>
    </transition>
    <!-- 尾页 -->
    <transition name="fade">
      <ending v-show="ending.show" @showShare="share.show = true" @action="action"></ending>
    </transition>
    <!-- 分享蒙版 -->
    <transition name="fade">
      <share v-show="share.show" @click.native="hideShare"></share>
    </transition>
  </div>
</template>

<script>
import music from '@/components/music'
import loading from '@/components/loading'
import home from '@/components/home'
import scene from '@/components/scene'
import ending from '@/components/ending'
import share from '@/components/share'

export default {
  name: 'App',

  components: { music, loading, home, scene, ending, share },

  data() {
    return {
      playMusic: false,
      loading: {
        show: false,
        progress: 0,
        enabledHide: false, // 3秒后可进入
      },
      home: {
        show: false,
        showText: false
      },
      scene: {
        show: false,
      },
      ending: {
        show: false
      },
      share: {
        show: false,
      }
    }
  },
  methods: {
    init() {
      // 微信加载完毕事件
      document.addEventListener('WeixinJSBridgeReady', this.initMusic)
      // 防止无法播放
      document.body.addEventListener('touchstart', this.initMusic)

      this.$bus.$on('loadProgress', (p) => {
        this.loading.progress = Math.ceil(p)
        if (this.loading.progress >= 100) {
          this.loading.progress = 100
          this.loaded()
        }
      })
      this.$refs.scene.init()

      // 3.5秒后可以进入首页
      setTimeout(() => {
        this.loading.enabledHide = true
        this.loaded()
      }, 3500)

      this.loading.show = true
    },
    initMusic() {
      if (!this.playedMusic && this.$bus.musicOn) {
        this.$bus.loadMusic()
        this.$bus.playMusic('bg')
        this.playedMusic = true
      }
    },
    hideShare() {
      this.share.show = false;
    },
    loaded() {
      if (this.loading.progress >= 100 && this.loading.enabledHide) {
        this.scene.show = true;
        this.home.show = true;
        setTimeout(() => {
          this.loading.show = false;
          this.home.showText = true;
        }, 1000)
      }
      // this.toScene()
    },
    toScene() {
      setTimeout(() => {
        this.home.show = false
        this.$refs.scene.start()
      }, 200)
    },
    toEnding() {
      this.$bus.clearRandomTimeout()
      this.ending.show = true
      this.$bus.playMusic('typing1');
      setTimeout(() => {
        this.$bus.playMusic('car')
      }, 3000)
    },
    action() {
      window.location.replace(this.$bus.link)
    },
    skip() {
      this.toEnding()
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss">
@import '~@/style/mixin.scss';

html, body {
  padding: 0;
  margin: 0;
}

.app {
  font-family: Arial, Helvetica, sans-serif;
  @include bg-cover;
  background-image: url("~@/assets/imgs/loading/bg.png");
  // background: white;
  width: 100vw;
  height: 100vh;
  font-size: .16rem;
  &__btns {
    position: absolute;
    top: 0;
    width: 100vw;
    left: 0;
    z-index: 900;
    &__skip {
      width: .8rem;
      position: absolute;
      top: 0;
      left: 0;
      padding: .3rem .28rem;
    }
  }
}
</style>
